import script from "./TaskCreateRate.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCreateRate.vue?vue&type=script&setup=true&lang=js"

import "./TaskCreateRate.vue?vue&type=style&index=0&id=3190757d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3190757d"]])

export default __exports__